import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px 50px;
  margin: 0 auto 35px;

  a {
    text-decoration: none;
    color: #272727;
  }

  @media (max-width: 980px) {
    padding: 0 16px;
  }
`;

export const FiltersContainer = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  gap: 20px;
  margin-bottom: 35px;
  flex-wrap: wrap;

  > div {
    min-width: 200px;
    flex: 1;
    max-width: 300px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    > div {
      max-width: 100%;
    }
  }
`;

export const NoEventsText = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  color: #666666;
  text-align: center;
  padding: 60px 20px;
  margin: 0 auto;
  width: 100%;
`;
